import { render, staticRenderFns } from "./TimeSubmissionV2.vue?vue&type=template&id=1a986135&scoped=true&"
import script from "./TimeSubmissionV2.vue?vue&type=script&lang=js&"
export * from "./TimeSubmissionV2.vue?vue&type=script&lang=js&"
import style0 from "./TimeSubmissionV2.vue?vue&type=style&index=0&id=1a986135&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a986135",
  null
  
)

export default component.exports